var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { error } from '../Env';
import { doWhenP } from '../utils';
import { cookie, getStrippedDomain } from '../web';
import { getCacheItem, setCacheItem } from '../cache';
import { getRequestId, updateRequest } from '../dataLayer';
export const VISITOR_CACHE_KEY = 'sent_visitor_id';
export const VISITOR_ID_COOKIE = 'clVisitorId';
export function sendVisitorId(requestId) {
    return __awaiter(this, void 0, void 0, function* () {
        var _a, _b, _c;
        if (getCacheItem(VISITOR_CACHE_KEY))
            return;
        const curVisitorId = cookie(VISITOR_ID_COOKIE);
        const visitor_id = {
            request_id: requestId,
            visitor_id: curVisitorId,
        };
        const res = yield updateRequest(requestId, { visitor_id });
        setCacheItem(VISITOR_CACHE_KEY, true);
        const returnedVisitorId = (_c = (_b = (_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.visitor_id) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.visitor_id;
        if (returnedVisitorId && returnedVisitorId !== curVisitorId) {
            cookie(VISITOR_ID_COOKIE, returnedVisitorId, 86400 * 365 * 5, null, getStrippedDomain());
        }
    });
}
/**
 * VisitorId is an extremely long-lived per-domain cookie.
 * It's used to identify return visitors to the same website.
 * */
export function run(expiration = 10000) {
    return doWhenP(() => getRequestId(), expiration, false)
        .then(requestId => sendVisitorId(requestId))
        .catch(e => {
        error('error updating visitor ID', e);
    });
}
//# sourceMappingURL=visitorId.js.map